export default __webpack_public_path__ + "static/media/janebi.74ee764c.png";